import { createGlobalStyle } from "styled-components";

// import ProximaSoftBoldWoff from "../../assets/fonts/proxima-soft-bold.woff";
// import ProximaSoftBoldWoff2 from "../../assets/fonts/proxima-soft-bold.woff2";
// import ProximaSoftLightWoff from "../../assets/fonts/proxima-soft-light.woff";
// import ProximaSoftLightWoff2 from "../../assets/fonts/proxima-soft-light.woff2";
// import ProximaSoftMediumWoff from "../../assets/fonts/proxima-soft-mediun.woff";
// import ProximaSoftMediumWoff2 from "../../assets/fonts/proxima-soft-mediun.woff2";
import ProximaSoftWoff from "../../assets/fonts/proxima-soft.woff";
import ProximaSoftWoff2 from "../../assets/fonts/proxima-soft.woff2";

export default createGlobalStyle`
    @font-face {
        font-family: 'proxima';
        src: local('proxima'), local('FontName'),
        url(${ProximaSoftWoff2}) format('woff2'),
        url(${ProximaSoftWoff}) format('woff');
        font-weight: 300;
        font-style: normal;
    }
  
`;
/**
 *   @font-face {
        font-family: 'proxima medium';
        src: local('proxima'), local('FontName'),
        url(${ProximaSoftMediumWoff2}) format('woff2'),
        url(${ProximaSoftMediumWoff}) format('woff');
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: 'proxima bold';
        src: local('proxima'), local('FontName'),
        url(${ProximaSoftBoldWoff2}) format('woff2'),
        url(${ProximaSoftBoldWoff}) format('woff');
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: 'proxima bold';
        src: local('proxima'), local('FontName'),
        url(${ProximaSoftBoldWoff2}) format('woff2'),
        url(${ProximaSoftBoldWoff}) format('woff');
        font-weight: 300;
        font-style: normal;
    }
     @font-face {
        font-family: 'proxima light';
        src: local('proxima'), local('FontName'), 
        url(${ProximaSoftLightWoff2}) format('woff2'),
        url(${ProximaSoftLightWoff}) format('woff') ;
        font-weight: 300;
        font-style: normal;
    }
 */
